import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {Calcolo} from "@commons/services/presenze_calcolo/Calcolo";
import {GestionePlus} from "@commons/services/presenze_calcolo/GestionePlus";
import {AccumuloRecord} from "@commons/mapping/AccumuloRecord";

export class Accumuli {
    static aggiornaSaldiAccumuli = (that: Pick<GestionePlus, 'mese' | 'days' | 'totaliMese' | 'currentWeek'>,
                                    weekRif: StatoWeekPLUSRecord | null,
                                    dayRif: PresenzeGiornataPlusRecord | null = null) => {
        if (that.days && that.days.length && that.totaliMese) {
            const lastDay = that.days[that.days.length - 1];
            if (that.totaliMese.accumuliCHK) {
                for (let indCHK = 0; indCHK < that.totaliMese.accumuliCHK.length; ++indCHK) {
                    const accumulo = that.totaliMese.accumuliCHK[indCHK];
                    switch (accumulo.periodo) {
                        case 'GIORNO':
                            accumulo.saldoPeriodo = 0;
                            if (dayRif) {
                                accumulo.saldoPeriodo = AccumuloRecord._calcolaSaldo(accumulo, lastDay, dayRif, 0, null, false);
                            } else if (that.currentWeek && that.currentWeek.currentDay) {
                                accumulo.saldoPeriodo = AccumuloRecord._calcolaSaldo(accumulo, lastDay, that.currentWeek.currentDay, 0, null, false);
                            }
                            break;

                        default:
                            if ((weekRif === null && accumulo.periodo !== 'SETTIMANA') ||  // Calcolo solo accumuli per PERIODO o ANNO
                                (weekRif !== null && accumulo.periodo === 'SETTIMANA') // Calcolo solo accumuli per SETTIMANA alla settimana specificata
                            ) {
                                accumulo.saldoPeriodo = accumulo.saldoIniziale;
                                const calcolaSaldo = function (giornata: PresenzeGiornataPlusRecord, indexGiornata: number, weekRif: StatoWeekPLUSRecord | null, soloMeseRif: boolean) {
                                    accumulo.saldoPeriodo += AccumuloRecord._calcolaSaldo(accumulo, lastDay, giornata, indexGiornata, weekRif, soloMeseRif);
                                };
                                let soloMeseRif;
                                if (accumulo.periodo === 'ANNO' || accumulo.periodo === 'VALIDITA') {
                                    soloMeseRif = false;
                                } else {
                                    soloMeseRif = (weekRif === null); // se weekRif !==null allora verifico anche settimana a cavallo (check settimanale), altrimenti solo mese di riferimento (check mese);
                                }
                                // fun, weekRif, soloMeseRif
                                Calcolo.forEachDay(that.days, that.mese, calcolaSaldo, weekRif, soloMeseRif);
                            }
                            break;
                    }
                }
            }
        }
    }
}